import axiosIns from '@/libs/axios'

const ROOT_URL = '/indicators'

export default {
  namespaced: true,
  state: {
    rows: [],
    summary: {
      overview: {},
      byDecisionModule: [],
      byFamily: [],
      recent: [],
      filters: {},
    },
    settings: {
      enabled: false,
      market: 'FUTURES',
      intervalMinutes: 0,
      selectionMode: 'SINGLE_LEADER',
      candidateLimit: 1,
      handoffGraceMinutes: 30,
      candidateIndicatorIds: [],
      handoffUntilAt: null,
    },
    loading: false,
    saving: false,
    dataSave: {
      message: null,
      status: null,
    },
  },
  getters: {
    rows(state) { return state.rows },
    summary(state) { return state.summary },
    settings(state) { return state.settings },
    loading(state) { return state.loading },
    saving(state) { return state.saving },
    dataSaveStatus(state) { return state.dataSave },
  },
  mutations: {
    SET_ROWS(state, rows) { state.rows = rows || [] },
    SET_SUMMARY(state, summary) {
      state.summary = {
        overview: {},
        byDecisionModule: [],
        byFamily: [],
        recent: [],
        filters: {},
        ...(summary || {}),
      }
    },
    SET_SETTINGS(state, settings) { state.settings = { ...state.settings, ...(settings || {}) } },
    SET_LOADING(state, val) { state.loading = val },
    SET_SAVING(state, val) { state.saving = val },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    async fetch({ commit, state }, params) {
      commit('SET_LOADING', true)
      const body = params || { market: state.settings.market || 'FUTURES' }
      const summaryBody = {
        market: body.market || state.settings.market || 'FUTURES',
        hours: body.hours || 24,
        limit: body.limit || 25,
        indicatorId: body.indicatorId,
        edgeId: body.edgeId,
        symbol: body.symbol,
        timeframe: body.timeframe,
        family: body.family,
      }
      try {
        const [performanceResult, summaryResult] = await Promise.allSettled([
          axiosIns.post(`${ROOT_URL}/performance`, body),
          axiosIns.post(`${ROOT_URL}/signal-outcomes/summary`, summaryBody),
        ])

        if (performanceResult.status === 'fulfilled') {
          const data = performanceResult.value.data.data || {}
          commit('SET_ROWS', data.rows || [])
          commit('SET_SETTINGS', data.settings || {})
        } else {
          console.error(performanceResult.reason)
          const msg = performanceResult.reason?.response?.data?.message || 'Performans listesi alınamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        }

        if (summaryResult.status === 'fulfilled') {
          commit('SET_SUMMARY', summaryResult.value.data.data || {})
        } else {
          console.error(summaryResult.reason)
          commit('SET_SUMMARY', {})
        }
      } finally {
        commit('SET_LOADING', false)
      }
    },
    fetchSettings({ commit }) {
      return axiosIns.get(`${ROOT_URL}/auto-selection`)
        .then(response => {
          commit('SET_SETTINGS', response.data.data || {})
        })
        .catch(error => {
          console.error(error)
        })
    },
    updateSettings({ commit, dispatch }, body) {
      commit('SET_SAVING', true)
      return axiosIns.put(`${ROOT_URL}/auto-selection`, body)
        .then(response => {
          commit('SET_SETTINGS', response.data.data || {})
          commit('SET_DATA_SAVE', { status: true, message: 'Ayar güncellendi.' })
          dispatch('fetch', { market: response.data.data?.market || body.market || 'FUTURES' })
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Ayar güncellenemedi.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
        .finally(() => commit('SET_SAVING', false))
    },
    runNow({ commit, dispatch }) {
      commit('SET_SAVING', true)
      return axiosIns.post(`${ROOT_URL}/auto-selection/run`, {})
        .then(response => {
          const data = response.data.data || {}
          commit('SET_DATA_SAVE', {
            status: true,
            message: data.changed ? 'İlk sıradaki indikatöre geçildi.' : 'Kontrol tamamlandı.',
          })
          dispatch('fetch')
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Kontrol çalıştırılamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
        .finally(() => commit('SET_SAVING', false))
    },
  },
}
